import React, { useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@material-ui/core/Button';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      flexGrow: 1,
    },
    img: {
      height: 600,
      display: 'block',
        width:'100%',
        objectFit:'cover',
      overflow: 'hidden',
    },
}));

const CarouselProductos = ({imagenes}) => {
    const classes = useStyles();
    const theme = useTheme();
    const [activeStep, setActiveStep] = useState(0);
    const maxSteps = imagenes.length;

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStepChange = (step) => {
        setActiveStep(step);
    };

    const isVideo = (file) => {
        return file.app_simple_storage_object_doc_type === 'video';
    };


    const extractYouTubeVideoId = (url) => {
        const patterns = [
            /(?:youtube\.com\/watch\?v=)([^&]+)/,
            /(?:youtu\.be\/)([^?]+)/,
            /(?:youtube\.com\/embed\/)([^?]+)/
        ];

        for (const pattern of patterns) {
            const match = url.match(pattern);
            if (match && match[1]) {
                return match[1];
            }
        }

        return null;
    };
    
    const getYoutubeThumbnail = (url) => {
        const videoId = extractYouTubeVideoId(url);
        if (!videoId) return '';

        return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    }

    const renderVideoThumbnail = (file) => {
        const thumbnailUrl = getYoutubeThumbnail(file.app_simple_storage_object_url);
        return (
            <div style={{ position: 'relative' }} key={file.app_simple_storage_object_id}>
                <LazyLoadImage
                    effect="blur"
                    src={thumbnailUrl}
                    alt={file.app_simple_storage_object_user_filename}
                    className={classes.img}
                />
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        fontSize: '64px',
                        color: 'red',
                        opacity: 0.8,
                        cursor: 'pointer',
                    }}
                    onClick={() => window.open(file.app_simple_storage_object_url, '_blank')}
                >
                    <i className="fas fa-play-circle"></i>
                </div>
            </div>
        );
    }

    return (
        <div className={classes.root}>
            <AutoPlaySwipeableViews
                interval={4000}
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
            >
                {imagenes.map((step, index) => (
                <div key={step.app_simple_storage_object_id}>
                    {Math.abs(activeStep - index) <= 2 ? (
                    isVideo(step) ? renderVideoThumbnail(step) : (
                        <LazyLoadImage key={step.app_simple_storage_object_id} effect="blur" src={step.app_simple_storage_object_url} alt={step.app_simple_storage_object_user_filename} className={classes.img}/>
                    )
                    ) : null}
                </div>
                ))}
            </AutoPlaySwipeableViews>
            <MobileStepper
                steps={maxSteps}
                position="static"
                variant="text"
                activeStep={activeStep}
                nextButton={
                <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                    Siguiente
                    {theme.direction === 'rtl' ? <i className="fas fa-arrow-left"></i> : <i className="fas fa-arrow-right"></i>}
                </Button>
                }
                backButton={
                <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                    {theme.direction === 'rtl' ? <i className="fas fa-arrow-right"></i> : <i className="fas fa-arrow-left"></i>}
                    Anterior
                </Button>
                }
            />
        </div>
    );
}
 
export default CarouselProductos;